import _ from 'underscore';
import { useCallback, useState, useMemo } from 'react';
import {
  CSMLSortBy, getSortingOptionsV3, handleRealUsedFlag,
} from '@bingads-webui-campaign-react/asset-library-model';

export const useSortBy = ({
  logger,
  preference,
  i18n,
  accountPreference,
  realUsedFlagSuffix,
}) => {
  const [sortBy, setSortBy] = useState(null);

  const sortingOptions = useMemo(
    () => getSortingOptionsV3(i18n),
    [i18n]
  );

  const safeSetSortBy = useCallback((newVal) => {
    const allSortByOptions = Object.values(CSMLSortBy);
    let safeNewValue = CSMLSortBy.MostRecent; // default vaue
    if (_.contains(allSortByOptions, newVal)) {
      safeNewValue = newVal;
    }
    setSortBy(safeNewValue);
    return safeNewValue;
  }, []);

  const onSortByChange = useCallback((_evt, item) => {
    if (item) {
      const newVal = safeSetSortBy(item.key);
      logger.logTrace('onSortByChange', { sortby: newVal });
      if (preference) {
        // save preferences
        preference.setSortBy(newVal);
      }
      handleRealUsedFlag(accountPreference, realUsedFlagSuffix);
    } else {
      // shouldn't happen
      logger.logError('onSortByChange, invalid key ');
    }
  }, [logger, preference, safeSetSortBy, accountPreference, realUsedFlagSuffix]);

  return {
    sortBy,
    sortingOptions,
    setSortBy: safeSetSortBy,
    onSortByChange,
  };
};
